export { default as MediaCollectionSupportingContent } from './MediaCollectionSupportingContent';
